import { render, staticRenderFns } from "./Horarios.vue?vue&type=template&id=745d5f60"
import script from "./Horarios.vue?vue&type=script&lang=js"
export * from "./Horarios.vue?vue&type=script&lang=js"
import style0 from "./Horarios.vue?vue&type=style&index=0&id=745d5f60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports